/**
* In this file use to contains the Parent Module Dashboard screen UI and Logic
**/
import { Link } from 'react-router-dom';
import { useState } from 'react';
import moment from 'moment';


function Dashboard() {
	
	//Intial state declaration
	// eslint-disable-next-line
	const [data,setData]=useState({});	

  return (
  <main id="main" className="main">		
	<div className="row">
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V01-bp-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				  <h6>Blood Pressure</h6>
				  <span> {data?.blood_pressure?.date ? moment(data.blood_pressure.date).fromNow() : ''}</span>
				</div>
				<div  className="data">
				  <h5>{data?.blood_pressure?data?.blood_pressure?.systolic+'/'+data?.blood_pressure?.diastolic:'--'}</h5>
				  <span>mmHg</span><br/>
				  <Link  className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Blood Bressure*/}
		
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V02-os-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				  <h6>Oxygen Saturation</h6>
				  <span> {data?.oxygen_saturation?.date ? moment(data.oxygen_saturation.date).fromNow() : ''}</span>
				</div>
				<div className="data">
				  <h5>{data?.oxygen_saturation?.value?data?.oxygen_saturation?.value:'--'}%</h5>
				  <Link className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Oxygen Saturation*/}
		
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V03-hr-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				   <h6>Heart Rate</h6>
				  <span> {data?.heart_rate?.date ? moment(data.heart_rate.date).fromNow() : ''}</span>
				</div>
				<div className="data">
				  <h5>{data?.heart_rate?.value?data?.heart_rate?.value:'--'}</h5>
				  <span>bpm</span><br/>
				  <Link className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Heart Rate*/}
		
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V04-bg-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				  <h6>Blood Glucose</h6>
				  <span> {data?.blood_glucose?.date ? moment(data.blood_glucose.date).fromNow() : ''}</span>
				</div>
				<div className="data">
				  <h5>{data?.blood_glucose?.value?data?.blood_glucose?.value:'--'}</h5>
				  <span>mg/dL</span><br/>
				  <Link className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Blood Glucose*/}
		
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V05-tm-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				   <h6>Temperature </h6>
				  <span> {data?.temperature?.date ? moment(data.temperature.date).fromNow() : ''}</span>
				</div>
				<div className="data">
				  <h5>{data?.temperature?.value?data?.temperature?.value:'--'}</h5>
				  <span><sup>o</sup>F</span><br/>
				  <Link className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Temperature*/}
		
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V06-wt-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				  <h6>Weight</h6>
				  <span> {data?.weight?.date ? moment(data.weight.date).fromNow() : ''}</span>
				</div>
				<div className="data">
				  <h5>{data?.weight?.value?data?.weight?.value:'--'}</h5>
				  <span>lbs</span><br/>
				  <Link className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Weight*/}
		
		<div className="col-xxl-6">
		  <div className="vital-card">
			  <div className="d-flex align-items-center">
				<div className="card-icon d-flex align-items-center justify-content-center">
				   <img src="/assets/img/icons/V03-hr-icon.svg" alt="IMG"/>
				</div>
				<div className="vital">
				  <h6>Respiratory</h6>
				  <span> {data?.respiratory?.date ? moment(data.respiratory.date).fromNow() : ''}</span>
				</div>
				<div className="data">
				  <h5>{data?.respiratory?.value?data?.respiratory?.value:'--'}</h5>
				  <span>lbs</span><br/>
				  <Link className="view-history" >View History</Link>
				</div>
			  </div>
		  </div>
		</div>
		{/*End Respiratory*/}
	</div>
	{/*<div className="row">
	  <div className="col-12">
	    <i data-bs-toggle="tooltip" onClick={()=>setModal({show:true})} data-bs-placement="bottom" title="Chat Bot" className="text-primary fas fa-comment-dots fa-2xl float-end"></i>
	  </div>
	</div>*/}
  </main>
  );

}

export default Dashboard;
